import { ObjectTypes } from '../types';

const iconClassByObjectType = {
    [ObjectTypes.Document]: 'fa-file-lines',
    [ObjectTypes.MediaBank]: 'fa-file-image',
    [ObjectTypes.Quiz]: 'fa-question',
    [ObjectTypes.TodoList]: 'fa-list-check',
};

export function getIconClassByObjectType(objectType: ObjectTypes): string {
    return iconClassByObjectType[objectType];
}
